import { useQuery } from '@tanstack/react-query'
import axiosAPI from '../axiosAPI';

export const useExpenseCategories = (accountId, filter = false) => { 

    const query = useQuery( ["expenseCategories"], () => 
        axiosAPI.get('/categories/expenses')
        .then((res) => res.data)
    );

    return {expenseCategories: query.data?.expense_categories, isLoading: query.isLoading, isError: query.error, isFetching: query.isFetching, refetch: query.refetch}

}
